import { useState, useEffect } from "react";
import { BodyWithClass, Btn } from "@client/ui";
import { useNavigate } from "react-router-dom";

const GroceryHeroSection: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const groceryTypes = [
    {
      type: "Supermarkets",
      image: "/image/supermarket.jpg",
      description:
        "Provide home delivery for groceries with our reliable logistics network.",
    },
    {
      type: "Fresh Produce Markets",
      image: "/image/produce-market.jpg",
      description:
        "Deliver fresh fruits and vegetables to customers' doorsteps efficiently.",
    },
    {
      type: "Specialty Food Stores",
      image: "/image/specialty-food.jpg",
      description:
        "Expand your reach for specialty and gourmet food items across the city.",
    },
    {
      type: "Corner Shops",
      image: "/image/corner-shop.jpg",
      description:
        "Quick deliveries for convenience items to the local neighborhood.",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % groceryTypes.length);
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, [groceryTypes.length]);

  const navigateToGroceryPage = () => {
    navigate("/grocery-partner");
  };

  return (
    <div className="bg-background-light max-w-full w-[700px] m-auto py-8 px-4 rounded-[12px] mb-[50px]">
      <BodyWithClass
        className="font-primary text-[24px] text-center font-semibold"
        text="Groceries Delivered with Tapzus"
      />
      <div className="mt-4 text-center">
        <BodyWithClass
          className="hero-section text-[20px] font-medium"
          text="Partner with us to deliver groceries on demand"
        />
        <BodyWithClass
          className="additional-text text-[18px] text-gray-600 mt-2"
          text="Connect with more customers and increase your store's revenue by offering convenient home delivery through Tapzus."
        />
        <BodyWithClass
          className="benefits-text text-[16px] text-gray-500 mt-4"
          text="Our platform helps grocery retailers of all sizes compete in the digital marketplace with minimal overhead."
        />
      </div>

      <div className="w-full border-primary border-t-1 mt-6 pt-[30px]">
        <BodyWithClass
          className="image-text text-[20px] font-medium text-center mb-4"
          text="For all types of grocery businesses"
        />

        {/* Image carousel */}
        <div className="relative h-[300px] overflow-hidden rounded-lg shadow-md">
          {/* Images with fade transition */}
          {groceryTypes.map((grocery, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 flex flex-col ${
                index === currentIndex ? "opacity-100 z-10" : "opacity-0 z-0"
              }`}
            >
              <div className="relative h-[220px] overflow-hidden">
                <img
                  src={grocery.image}
                  alt={grocery.type}
                  className="w-full h-full object-cover transition-transform duration-700 ease-in-out transform hover:scale-105"
                />
                <div className="absolute top-0 left-0 bg-gradient-to-r from-green-900/70 to-transparent px-4 py-2 rounded-br-lg">
                  <h3 className="text-white font-bold text-lg">
                    {grocery.type}
                  </h3>
                </div>
              </div>
              <div className="bg-white p-4 h-[80px] flex items-center justify-center">
                <p className="text-center text-gray-700">
                  {grocery.description}
                </p>
              </div>
            </div>
          ))}

          {/* Indicator dots */}
          <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
            {groceryTypes.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-colors ${
                  index === currentIndex ? "bg-green-600" : "bg-gray-300"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="mt-8 text-center">
        <Btn
          text="Become a Grocery Partner"
          onClick={navigateToGroceryPage}
          style={{
            backgroundColor: "#16a34a",
            color: "white",
            padding: "10px 24px",
            borderRadius: "8px",
            fontWeight: "600",
          }}
        />
      </div>
    </div>
  );
};

export default GroceryHeroSection;
